/**
 * Shows a short summary of the required fields a user still needs to fill in
 * before an event can be published. Renders nothing when there are no errors.
 *
 * The `errors` map is the same `Record<string, string>` the create/edit forms
 * already maintain — its values are user-facing messages (e.g. "Title is
 * required"), so we just list them near the Publish button.
 */
export function MissingFieldsNotice({ errors }: { errors: Record<string, string> }) {
  const messages = Array.from(new Set(Object.values(errors).filter(Boolean)))
  if (messages.length === 0) return null

  return (
    <div
      role="alert"
      className="px-4 py-3 rounded-xl bg-danger-soft border border-danger-line text-danger-deep text-[13px]"
    >
      <div className="font-semibold mb-1">
        {messages.length === 1
          ? 'Please fix this before publishing:'
          : `Please fix ${messages.length} things before publishing:`}
      </div>
      <ul className="list-disc pl-5 space-y-0.5">
        {messages.map((msg) => (
          <li key={msg}>{msg}</li>
        ))}
      </ul>
    </div>
  )
}
